module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "el-upload-dragger",
    class: {
      'is-dragover': _vm.dragover
    },
    on: {
      "drop": function($event) {
        $event.preventDefault();
        _vm.onDrop($event)
      },
      "dragover": function($event) {
        $event.preventDefault();
        _vm.onDragover($event)
      },
      "dragleave": function($event) {
        $event.preventDefault();
        _vm.dragover = false
      }
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@10.3.0@vue-loader/lib/template-compiler.js?id=data-v-198d8633!./~/_vue-loader@10.3.0@vue-loader/lib/selector.js?type=template&index=0!./src/components/uploader/src/upload-dragger.vue
// module id = 618
// module chunks = 0